module.exports = __webpack_public_path__ + "img/hr-level3addon_running_shadow.cc9f69be.png";